declare global {
  interface Window {
    Trustpilot: {
      loadFromElement: (element: Element, forceReload: boolean) => void;
    };
  }
}

export const loadTrustPilotWidgets = (): void => {
  if (typeof document === "undefined" || !window.Trustpilot) return;

  const elements = document.getElementsByClassName("trustpilot-widget");
  for (const element of elements) {
    window.Trustpilot.loadFromElement(element, false);
  }
};
